function parseData(data) {
  return JSON.stringify(data);
}

function logMessage(message) {
}

function serviceFactory({ api }) {
  const requestResetCode = ({ username, email, platform, langCode }) =>
    api.requestResetCode(username, email, platform, langCode)
      .then((data) => {
        logMessage('requestResetCode service');
        return parseData(data);
      })
      .catch((data) => {
        logMessage('requestResetCode service');
        return parseData(data);
      });

  const verifyResetCode = ({ resetCodeId, resetCodeValue }) =>
    api.verifyResetCode(resetCodeId, resetCodeValue)
      .then((data) => {
        logMessage('verifyResetCode service');
        return parseData(data);
      })
      .catch((data) => {
        logMessage('verifyResetCode service');
        return parseData(data);
      });
  const verifyResetCodeExtended = ({ resetCodeId, resetCodeValue, channel }) =>
    api.verifyResetCodeExtended(resetCodeId, resetCodeValue, channel)
      .then((data) => {
        logMessage('verifyResetCodeExtended service');
        return parseData(data);
      })
      .catch((data) => {
        logMessage('verifyResetCodeExtended service');
        return parseData(data);
      });

  const resendResetCode = ({ resetCodeId, langCode }) =>
    api.resendResetCode(resetCodeId, langCode)
      .then((data) => {
        logMessage('resendResetCode service');
        return parseData(data);
      })
      .catch((data) => {
        logMessage('resendResetCode service');
        return parseData(data);
      });

  const changePassword = ({ token, userId, newCryptoPassword, langCode, metaData }) =>
    api.changePassword(token, userId, newCryptoPassword, langCode, metaData)
      .then((data) => {
        logMessage('changePassword service');
        return parseData(data);
      })
      .catch((data) => {
        logMessage('changePassword service');
        return parseData(data);
      });

  return {
    requestResetCode,
    verifyResetCode,
    verifyResetCodeExtended,
    resendResetCode,
    changePassword,
  };
}

module.exports = serviceFactory;
